import SchoolBasementB2 from "../../exploration/dungeons/schoolbasement/SchoolBasementB2";
import {
  hasFlag,
  hasGlobalFlag,
  hasGlobalFlagIncludingNextRun,
  setFlag,
  setGlobalFlag,
} from "../../Flags";
import {
  getTotalAmountOfItem,
  removeFromInventoryWithAnyParams,
} from "../../items/Inventory";
import Cloth from "../../items/other/Cloth";
import { addContextListener } from "../../PlayerContextListeners";
import { Storyline, Storylines } from "../../storylines/Storylines";
import { buildEvent } from "../EventMessageBuilder";
import { triggerEvent } from "../Events";
import { EventTag } from "../GameEvent";

const monsterEncyclopediaEB = buildEvent(
  "monster_encyclopedia",
  "(Storyline) Foe Encyclopedia",
  [EventTag.STORYLINE],
);

monsterEncyclopediaEB
  .setOnTrigger(setFlag("monster_encyclopedia_triggered"))
  .createMessage()
  .setSimpleDescription(
    `You have now felled a small variety of different enemies in your exploration of the school. Many of them, you realize that you're seeing over and over again.
    
It occurs to you that keeping track of those foes might become useful later on, as you notice them dropping unique, useful objects when you defeat them. Perhaps a record of this would help you in the future, in the case you need these?

You propose the idea to your researcher. She agrees that it is a good idea, nodding.`,
  )
  .addOption(
    "Continue",
    monsterEncyclopediaEB
      .createMessage()
      .setSimpleDescription(
        `Your apprentice shows up, his excitement clearly showing once more through the way he approaches you. "A *Bestiary*! A *record of our adventures*! We will *surely* become famous this way!"
        
You proceed to calm down the apprentice, as your researcher laughs a little. It'll certainly be useful...

You prepare to set up the book, and check once more to see if you have enough stationery...`,
      )
      .addOption(
        "Create a Bestiary (10 Cloth)",
        {
          transform: (state) => {
            state = removeFromInventoryWithAnyParams(Cloth, 10, state);
            return state;
          },
          isEnabled: (state, params) => {
            return getTotalAmountOfItem(Cloth, state) >= 10;
          },
        },
        monsterEncyclopediaEB
          .createMessage()
          .setSimpleDescription(
            `Cloth is probably not the best material, you think. But it'll have to do. You put it together, bind it with a makeshift book cover, and crudely etch "Bestiary" on it with big letters.
            
You show it to your researcher, who makes a face of disgust. You understand her feeling - it looks like a children's book cover. The apprentice, however, can't keep his eyes off the book, seemingly oblivious to this fact.`,
          )
          .addOption(
            "Continue",
            {
              transform: (state) => {
                state = setGlobalFlag("bestiary_unlocked")(state);
                return state;
              },
            },
            monsterEncyclopediaEB.createMessage().setSimpleDescription(
              `Well, you're certainly not very good at this... maybe it was a better idea to ask your researcher for help? Nevertheless, you jot down what you have learned from the foes. You are certain this will help you at some point in the future, and perhaps, it might also help others...
                
**You have cleared the "Foe Encyclopedia" Storyline! You have permanently unlocked the "Bestiary" feature. Defeat enemies enough times to see information about their stats, loot, and encounter chances. This will stay unlocked in future runs!**`,
            ),
          ),
      )
      .addOption("Maybe later"),
  );

Storylines.register(
  new Storyline(
    "Foe Encyclopedia",
    2060,
    (state) => hasGlobalFlagIncludingNextRun(state, "bestiary_unlocked"),
    (state) => hasGlobalFlag(state, "bestiary_unlocked"),
    "Explore the School Basement B2",
    'Unlock "Bestiary" feature',
    (state) => true,
  ),
);

const monsterEncyclopediaEvent = monsterEncyclopediaEB.build();

addContextListener("monster_encyclopedia_unlocked", (newState) => {
  if (
    !hasGlobalFlag(newState, "bestiary_unlocked") &&
    !hasFlag(newState, "monster_encyclopedia_triggered") &&
    (newState.exploration.successfulExplorationsPerFloor[
      SchoolBasementB2.getId()
    ] > 20 ||
      SchoolBasementB2.canFightBoss(newState))
  ) {
    return triggerEvent(monsterEncyclopediaEvent);
  }
});

export default monsterEncyclopediaEvent;
